import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import config from './config';
import plugins from './plugins';

const create = (options = {}) => {
  const {
    accessToken,
    ...opts
  } = {
    ...config,
    ...options,
  };

  mapboxgl.accessToken = accessToken;

  return new mapboxgl.Map(opts);
};

const map = {
  create,
  plugins,
};

window.localsearch = {
  ...window.localsearch,
  map,
};

export default map;
